import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
import { observable, runInAction } from "mobx";
let RpmProductVariantToSubscription = (_class = class RpmProductVariantToSubscription {
  constructor(data, store) {
    _initializerDefineProperty(this, "data", _descriptor, this);
    this.store = void 0;
    this.store = store;
    runInAction(() => {
      this.data = data;
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "data", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { RpmProductVariantToSubscription };